<style lang="less">
.home-page {
  padding-top: 74px;
  position: relative;
  .weui-search-bar {
    padding: 0px 15px;
  }
  .notices-fixed {
    width: 100%;
    position: fixed;
    top: 73px;
    left: 0;
    z-index: 1000;
  }
  .home-content {
    padding: 2.66vw;
    background: #eeeeee;
    .goods-list {
      padding: 0px !important;
      margin-top: 10px;
    }
  }
}
</style>
<template>
  <div class="home-page">
    <router-link :to="{path: '/search'}" class="search-bar">
			<search key="home-search" :readonly="true" :placeholder="placeholder" value="">
        <div class="saoyisao" v-show="isShowScanner" @click.stop.prevent="saoyisao" slot="right">
          <icon size="27" color="#2E2F30">saoyisao-erweimachaxun</icon>
        </div>
      </search>
    </router-link>
    <menus
      :categoryList="categoryList"
      :currentId="currentMenusId"
      @select-change="categoryChange"
      @onShowStateChange="whenMenusChange"
    >
    </menus>
    <div class="notices-fixed">
      <Notices
        @clearTime="clearTime"
        @isShow="
          data => {
            isShowNotices = data;
          }
        "
      />
    </div>
    <div
      class="home-content"
      :style="{ marginTop: isShowNotices ? '49px' : '0px' }"
    >
      <home-content-main :swipeAuto="swipeAuto"></home-content-main>
    </div>
    <default-page v-if="getError" :allReload="true" :showRefreshBtn="true" />
  </div>
</template>
<script>
import _ from "underscore";
import { MessageBox } from "mint-ui";
import { mapActions } from "vuex";
import search from "../../components/search.vue";
import icon from "../../components/icon";
import menus from "../../components/menus";
import { myToast } from "../../util/interaction.js";
import { app } from "../../util/platform";
import homeContentMain from "./sub_view/home_content_main";
import homeContentCategory from "./sub_view/home_content_category";
import wxsdk from "weixin-js-sdk";
import { resolveActionPath } from "../../util/function.js";
import { trackData } from "../../directives/track.js";
import defaultPage from "../../components/none-order";
import Notices from "./sub_view/news/news.vue";
export default {
  data() {
    return {
      isShowNotices: false,
      isShowScanner: app.isWechat(),
      categoryList: [
        {
          name: "推荐",
          id: -1
        }
      ],
      currentMenusId: 0,
      isShowAllMenus: false,
      getError: false,
      swipeAuto: true,
      unloadReadTime: (new Date).valueOf()
    }
  },
  beforeRouteLeave(to, from, next) {
    trackData({
      id: 1001,
      data: {
        sT: this.unloadReadTime,
        eT: (new Date).valueOf()
      }
    })
    // 路由跳转前，清除轮询
    if (window.timers) { 
      clearInterval(window.timers);
    }
    console.log("清除 time",to,from);
    next();
  },
  activated() {
    this.swipeAuto = true;
  },
  deactivated() {
    this.swipeAuto = false;
  },
  beforeRouteLeave(to, from, next) {
    trackData({
      id: 1001,
      data: {
        sT: this.unloadReadTime,
        eT: (new Date).valueOf()
      }
    })
    // 路由跳转前，清除轮询
    if (window.timers) {
      clearInterval(window.timers);
    }
    console.log("清除 time", to, from);
    next();
  },
  methods: {
    clearTime() {
      if (window.timers) {
        clearInterval(window.timers);
      }
    },
    ...mapActions(["getHomeMenus"]),
    categoryChange(activeId) {
      // this.currentMenusId = activeId
      if (activeId === this.categoryList[0].id) {
        return;
      }
      // trackData({id: 2001, p: [activeId]})
      // trackData({id: 2001})
      this.$router.push({
        path: `/home/${activeId}`
      });
    },
    saoyisao() {
      wxsdk.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          this.$store.dispatch('queryQrcode', {qrcode: res.resultStr}).then(result => {
            const href = resolveActionPath(result)
            this.$router.push(href)
          }).catch(e => { 
            MessageBox.alert(e)
          })
        },
        fail: e => {
          console.log("扫一扫调起失败", e);
        }
      });
    },
    whenMenusChange(IsShowAll) {
      this.isShowAllMenus = IsShowAll;
    }
  },
  computed: {
    shadings() {
      return this.$store.state.search.shadings;
    },
    placeholder() {
      return (this.shadings.length && this.shadings[0]) || "";
    }
  },
  mounted() {
    // this.currentMenusId = -1
    this.$store.dispatch("getShadingHotKeywords");
    this.getHomeMenus()
      .then(data => {
        this.categoryList = this.categoryList.concat(
          _.map(data, item => {
            return {
              name: item.name,
              id: item.categoryId
            };
          })
        );
        setTimeout(() => {
          this.currentMenusId = -1;
        }, 0);
      })
      .catch(e => {
        this.getError = true;
        myToast(e);
      });
  },
  components: {
    Notices,
    search,
    icon,
    menus,
    homeContentMain,
    homeContentCategory,
    defaultPage
  }
};
</script>
